import {
  IconButton,
  Tooltip
} from "@mui/material";
import React from "react";

import { NoAdultContentIcon } from "assets/icons";
import { ConfirmDeleteModal } from "new-components/modals/ConfirmDeleteModal";

export interface InappropriateFlagButtonProps {
  onUnclearSubmit: (feedbackText: string) => void;
}

export function InappropriateFlagButton(props: InappropriateFlagButtonProps) {
  const {
    onUnclearSubmit,
  } = props;

  const [openConfirmationModal, setOpenConfirmationModal] = React.useState(false);

  const handleSubmitInappropriateImage = () => {
    onUnclearSubmit("image contains inappropriate content");
    setOpenConfirmationModal(false);
  };

  return (
    <>
      <Tooltip title="Flag image as inappropriate" placement="top">
        <IconButton
          id="inappropriate-flag-button"
          onClick={() => setOpenConfirmationModal(true)}
          sx={{
            display: 'flex',
            width: '34px',
            height: '34px',
            border: '1px solid #919599',
            bgcolor: '#FFFFFF',
            color: 'white',
            borderRadius: '17px'
          }}
        >
          <NoAdultContentIcon color="#929599" />
        </IconButton>
      </Tooltip>

      <ConfirmDeleteModal
        isDeleteModalOpen={openConfirmationModal}
        setIsDeleteModalOpen={setOpenConfirmationModal}
        modalTitle="FLAG AS INAPPROPRIATE?"
        onRemoveHandler={handleSubmitInappropriateImage}
        modalContent="Are you sure you want to flag the image query as inappropriate?"
        buttonTexts={{
          successText: "Yes",
          cancelText: "Cancel",
        }}
      />
    </>
  )
}